import React from 'react';
import Testimonial from '../../components/testimonial/Testimonial';
import WhyChooseUs from '../../components/whychooseus/WhyChooseUs';
import Breadcrumb from '../common/Breadcrumb';
import Footer from '../common/Footer';
import Header from '../common/Header';
import { Helmet } from 'react-helmet';

function Medifacial() {
  return (
    <div>
      <Helmet>
        <title>Medifacial Treatment in Gurgaon | Swakaaya Aesthetics</title>
        <meta
          name='description'
          content='Revitalize your skin with advanced medifacial in Gurgaon at Swakaaya. Customized facials for hydration, glow and rejuvenation.'
        />
        <meta
          name='keywords'
          content='medifacial Gurgaon, advanced facials Gurgaon, skin clinic Gurgaon'
        />
        <link
          rel='canonical'
          href='https://swakaaya.com/our-services/medifacial'
        />

        <meta
          property='og:title'
          content='Medifacial Treatment in Gurgaon | Swakaaya Aesthetics'
        />
        <meta
          property='og:description'
          content='Revitalize your skin with advanced medifacial in Gurgaon at Swakaaya. Customized facials for hydration, glow and rejuvenation.'
        />
        <meta
          property='og:url'
          content='https://swakaaya.com/our-services/medifacial'
        />
        <meta property='og:type' content='website' />
        <meta
          property='og:image'
          content='https://swakaaya.com/assets/images/logo.png'
        />

        <meta name='twitter:card' content='summary_large_image' />
        <meta
          name='twitter:title'
          content='Medifacial Treatment in Gurgaon | Swakaaya Aesthetics'
        />
        <meta
          name='twitter:description'
          content='Revitalize your skin with advanced medifacial in Gurgaon at Swakaaya. Customized facials for hydration, glow and rejuvenation.'
        />
        <meta
          name='twitter:image'
          content='https://swakaaya.com/assets/images/logo.png'
        />
      </Helmet>
      <Header />
      <Breadcrumb title={'Medifacial'} />
      <section className='section section-padding-02 '>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='service-content'>
                <div>
                  <div>
                    <h2>
                      <strong> MEDIFACIAL </strong>
                    </h2>
                    <p>
                      MediFacial is an advanced skin treatment designed to go
                      beyond regular salon facials. Unlike normal facials that
                      work only on the surface of the skin, MediFacial is a
                      dermatologically designed procedure that penetrates deeper
                      and targets specific skin concerns. It helps in hydrating,
                      brightening, detoxifying, and rejuvenating the skin while
                      also treating acne, pigmentation, fine lines, and
                      dullness.
                    </p>
                    <p>
                      It is a safe, non-invasive, and highly effective treatment
                      suitable for all skin types, giving the skin an instant
                      glow and long-term benefits.
                    </p>
                    <p>
                      <strong>THE MEDIFACIAL PROCEDURE INCLUDES:</strong>
                    </p>
                    <ul>
                      <li>
                        The skin is first cleansed thoroughly to remove
                        impurities, dirt, and oil.
                      </li>
                      <li>
                        A gentle exfoliation is done to remove dead skin cells
                        and open pores.
                      </li>
                      <li>
                        Customized solutions such as vitamins, antioxidants, and
                        hydrating serums are infused into the skin using
                        advanced technology (like hydradermabrasion, oxygen
                        therapy, or electroporation).
                      </li>
                      <li>
                        Depending on the type of MediFacial chosen, LED light
                        therapy or masks may be applied to enhance results.
                      </li>
                      <li>
                        The session is completed with sunscreen or protective
                        skincare.
                      </li>
                    </ul>
                    <p>
                      The entire process usually takes 45 minutes to 1 hour and
                      has no downtime.
                    </p>
                    <p>
                      <strong>HOW LONG DOES IT TAKE TO SHOW RESULTS?</strong>
                    </p>
                    <p>
                      Results are usually visible immediately after the first
                      session — the skin feels fresher, smoother, and more
                      radiant. With regular sessions, long-term benefits such as
                      improved texture, reduced pigmentation, and anti-aging
                      effects can be achieved.
                    </p>
                    <p>
                      <strong>WHAT ARE THE BENEFITS OF MEDIFACIAL?</strong>
                    </p>
                    <ul>
                      <li>Deep hydration and nourishment of the skin</li>
                      <li>Reduction in acne, open pores, and blemishes</li>
                      <li>Brighter and even skin tone</li>
                      <li>Reduction in fine lines and early signs of aging</li>
                      <li>Safe and customizable for all skin types</li>
                      <li>
                        Immediate glow with long-lasting skin health benefits
                      </li>
                    </ul>
                    <p>
                      To ensure safety and effectiveness, MediFacial should
                      always be performed by trained dermatologists or skin
                      professionals using medical-grade products and devices.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <WhyChooseUs />
      <Testimonial />
      <Footer />
    </div>
  );
}

export default Medifacial;
